import { useTranslation } from 'react-i18next'

import { Link } from '@tanstack/react-router'

import { InfoIcon } from 'lucide-react'

import { PermissionGuard } from '@/components/PermissionGuard/PermissionGuard'
import { Button } from '@/components/ui/button'

export function AuditRetentionBanner() {
  const { t } = useTranslation()

  return (
    <div className="flex items-start gap-3 rounded-xl border border-blue-200 bg-blue-50/60 px-5 py-3 text-sm">
      <InfoIcon className="mt-0.5 size-4 shrink-0" aria-hidden />
      <div className="min-w-0">
        <p className="text-foreground">{t('executionLogs.infoBanner')}</p>
        <PermissionGuard permission="read:audit_export_config">
          <Button asChild variant="link" className="h-auto p-0 text-blue-700">
            <Link to="/settings/audit-exports">
              {t('executionLogs.viewSettings')}
            </Link>
          </Button>
        </PermissionGuard>
      </div>
    </div>
  )
}
